<template>
  <div>
    <b-icon-fonts></b-icon-fonts>
    <span v-for="option in options" :key="option" class="option" :class="[{ active: fontFamily === option }, `option--${option}`]" @click.stop.prevent="update(option)">Aa</span>
  </div>
</template>

<script>
  export default {
    props: ['fontFamily'],
    
    data() {
      return {
        options: ['default', 'serif', 'sans-serif']
      }
    },

    methods: {
      update(option) {
        this.$emit('update:fontFamily', option);
      }
    }
  }
</script>

<style scoped>
  svg {
    margin-right: 0.5em;
  }

  .option {
    position: relative;
    display: inline-block;
    color: #aaa;

    margin-right: 0.5em;
  }

  .option.active {
    font-weight: bold;
    color: #000;
  }

  .option--default {
    font-family: monospace;
  }

  .option--serif {
    font-family: Georgia, 'Times New Roman', Times, serif;
  }

  .option--sans-serif {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  }
</style>